import React, { useEffect, useState } from 'react'
import { toast, ToastContainer } from 'react-toastify'
import Header from '../../layouts/Header'
import Footer from '../../layouts/Footer'
import { GiSeaStar } from 'react-icons/gi'
import { IoIosArrowDropup } from 'react-icons/io'
import { useParams } from 'react-router-dom'
import { Url } from '../../UrlServer'
import './Details.css'
import ProductsRecommend from '../components/ProductsRecommend'
import { addToCartAPI, getCartAPI } from '../../../redux/actions/cart-actions'
import { useAppDispatch, useAppSelector } from '../../../store'
import { fetchProductDetailsAPI } from '../../../redux/actions/productActions'
import { formatUSD } from '../../../utils/formatter'
import Loading from '../../layouts/Loading'

interface CSSCustomizations extends React.CSSProperties {
  '--image': string
}

function Details() {
  const { product, loading } = useAppSelector(state => state.products)

  const dispatch = useAppDispatch()
  const params = useParams()
  const [readMore, setReadmore] = useState(false)
  const [show, setShow] = useState(true)
  const handleAddToCart = async (productID?: string) => {
    if (!productID) return

    const result = await dispatch(addToCartAPI({ product_id: productID }))
    toast.success(result.payload?.message)
  }

  useEffect(() => {
    dispatch(fetchProductDetailsAPI(params.productID || ''))
  }, [dispatch, params])

  return (
    <div className="main">
      {loading ? <Loading /> : null}
      <Header />
      <ToastContainer />
      {product !== null && product !== undefined ? (
        <div
          className="dtls-wrap"
          style={
            {
              '--image': product ? `url(${Url}/${product.image})` : 'none'
            } as CSSCustomizations
          }
        >
          <div
            className="dtls"
            key={product._id}
            style={
              {
                '--image': `url(${Url}/${product.image})`
              } as CSSCustomizations
            }
          >
            <div className="dt-img">
              <img src={`${Url}/${product.image}`} alt={product.name} />
            </div>
            <div className="dt-infor">
              <div className="basic">
                <p>{product.name}</p>
                <p>
                  Category:
                  {product?.category ? product.category.name : 'unknowm'}
                </p>
                <div className="rating-stars">
                  <GiSeaStar />
                  <GiSeaStar />
                  <GiSeaStar />
                  <GiSeaStar />
                  <GiSeaStar />
                </div>
                <p className="price">{formatUSD(product.price)}</p>
                <div className="btn-group-dt">
                  <button onClick={() => handleAddToCart(product?._id)}>
                    Add to cart
                  </button>
                </div>
              </div>
              <div className={readMore ? 'dt-view  read-more' : 'dt-view'}>
                <div className="v-ctl">
                  <button
                    id="decription"
                    className={show ? 'active' : ''}
                    onClick={() => setShow(true)}
                  >
                    Decription
                  </button>
                  <button
                    id="feedback"
                    className={show ? '' : 'active'}
                    onClick={() => setShow(false)}
                  >
                    Story
                  </button>
                </div>
                <div
                  className={show ? 'dt-view-wraper' : 'dt-view-wraper show'}
                >
                  <div className="infor-pl">
                    <p>{product.description}</p>
                  </div>
                  <div className="dt-feedback">
                    <p>{product?.category ? product.category.history : ''}</p>
                  </div>
                </div>
              </div>
              <IoIosArrowDropup
                className={readMore ? 'dt-readmore rotate' : 'dt-readmore'}
                onClick={() => setReadmore(!readMore)}
              />
            </div>
          </div>
        </div>
      ) : (
        'product not found'
      )}

      <div className="recommend">
        <h1>Related Products</h1>
      </div>
      <ProductsRecommend
        productID={product?._id || ''}
        categoryID={product?.category._id || ''}
      />
      <Footer />
    </div>
  )
}

export default Details
